import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import appcolors from "../../constants/Colors";
import moment from "moment";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { formattedDate, formattedTime } from "../../utils";
import { CURRENCY } from "../../constants/Variables";
import { t } from "i18next";
import { useSelector } from "react-redux";

export default function DashboardTable({
  headerData,
  tableData,
  diplayRows,
  minWidth,
  showHeader,
  handleNavigateToDetail,
}) {
  const { currentLanguage } = useSelector((state) => state.translationReducer);

  return (
    <TableContainer sx={{ marginTop: "12px" }}>
      <Table
        // sx={{
        //   minWidth: minWidth ? minWidth : 1000,
        // }}
        size="small"
        stickyHeader
      >
        <TableHead sx={{ display: showHeader ? "table-header-group" : "none" }}>
          <TableRow>
            {headerData?.map((column, _index) => (
              <TableCell
                key={_index}
                align={column.align}
                style={{
                  //   minWidth: column.minWidth,
                  color: appcolors.black,
                  fontWeight: "500",
                  fontSize: 14,
                  fontFamily: "Poppins",
                }}
              >
                <Typography fontWeight={500}>{t(column.label)}</Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {tableData
            //   .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            ?.map((row, ind) => {
              return (
                <TableRow key={ind}>
                  {diplayRows.map((val) => {
                    return (
                      <React.Fragment key={val}>
                        {val == "date_and_month" ? (
                          <TableCell padding="normal">
                            <Stack>
                              <Typography
                                variant="h1"
                                fontSize={"0.875rem"}
                                fontWeight={600}
                                color={appcolors.black}
                              >
                                {moment(row?.createdAt).format("DD")}
                              </Typography>
                              <Typography
                                variant="body1"
                                fontSize={"0.75rem"}
                                color={appcolors.gunmetal}
                                textTransform={"capitalize"}
                              >
                                {moment(row?.createdAt).format("MMM")}
                              </Typography>
                            </Stack>
                          </TableCell>
                        ) : val == "order_owner_data" ? (
                          <TableCell padding="normal">
                            <Stack>
                              <Typography
                                variant="h1"
                                fontSize={"0.875rem"}
                                fontWeight={600}
                                color={appcolors.black}
                              >
                                {`${row.userId.firstname} ${row.userId.lastname}`}
                              </Typography>
                              <Typography
                                variant="body1"
                                fontSize={"0.75rem"}
                                color={appcolors.gunmetal}
                                textTransform={"capitalize"}
                              >
                                {t("email")}:{row.userId.email}
                              </Typography>
                            </Stack>
                          </TableCell>
                        ) : val == "ed_quick_req_date_time" ? (
                          <TableCell
                            padding="normal"
                            color={"custom.silverChalice"}
                          >
                            <Typography variant="body1" lineHeight={"normal"}>
                              <strong style={{ marginRight: "6px" }}>
                                {moment(row.createdAt).format("DD")}
                              </strong>
                              {moment(row.createdAt).format("MMM")}
                            </Typography>
                            <Typography variant="body2" lineHeight={"normal"}>
                              {moment(row.createdAt).format("hh:mm a")}
                            </Typography>
                          </TableCell>
                        ) : val == "worker_new_appointement_detail" ? (
                          <TableCell padding="normal">
                            <Stack>
                              <Typography variant="body2">
                                {moment(row.createdAt).format(
                                  "ddd,DD MMM YYYY hh:mm a",
                                )}
                                <span
                                  style={{
                                    color: "lightgreen",
                                    marginLeft: 10,
                                  }}
                                >
                                  {t("after20min")}
                                </span>
                              </Typography>
                              <Typography variant="body1" fontWeight={500}>
                                {row.name}
                              </Typography>
                              <Typography variant="body2">
                                {t("address")} : {row.address}
                              </Typography>
                            </Stack>
                          </TableCell>
                        ) : val == "worker_appointment_price" ? (
                          <TableCell padding="normal">
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              gap={0.5}
                            >
                              <Typography variant="body2">
                                {row.price} per hr{" "}
                                <span style={{ fontWeight: 500 }}>USD</span>
                              </Typography>
                              <ArrowRightAltIcon />
                            </Stack>
                          </TableCell>
                        ) : val == "ownerData" ? (
                          <TableCell padding="normal">
                            <Stack>
                              <Typography
                                variant="h1"
                                fontSize={"0.875rem"}
                                fontWeight={600}
                                color={appcolors.black}
                              >
                                {row.name}
                              </Typography>
                              <Typography
                                variant="body1"
                                fontSize={"0.75rem"}
                                color={appcolors.gunmetal}
                                textTransform={"capitalize"}
                              >
                                {t("email")}:{row.email}
                              </Typography>
                              <Typography
                                variant="body1"
                                fontSize={"0.75rem"}
                                color={appcolors.gunmetal}
                                textTransform={"capitalize"}
                              >
                                {t("contact")}:{row.contact}
                              </Typography>
                              <Typography
                                variant="body1"
                                fontSize={"0.75rem"}
                                color={appcolors.gunmetal}
                                textTransform={"capitalize"}
                              >
                                {t("location")}:{row.location}
                              </Typography>
                            </Stack>
                          </TableCell>
                        ) : val == "showDetailBtn" ? (
                          <TableCell padding="normal">
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              gap={2}
                              sx={{ cursor: "pointer" }}
                              onClick={() => handleNavigateToDetail(row, ind)}
                            >
                              <Typography
                                variant="h1"
                                fontSize={"0.875rem"}
                                fontWeight={600}
                                color={appcolors.black}
                              >
                                {"details"}
                              </Typography>
                              <ArrowRightAltIcon />
                            </Stack>
                          </TableCell>
                        ) : val == "booker_name" ? (
                          <TableCell padding="normal">
                            <Typography
                              variant="h1"
                              fontSize={"0.875rem"}
                              fontWeight={400}
                              color={
                                row.isDone
                                  ? appcolors.black
                                  : appcolors.slateGrey
                              }
                            >
                              {row.name}
                            </Typography>
                          </TableCell>
                        ) : val == "booked_service" ? (
                          <TableCell padding="normal">
                            <Typography
                              variant="h1"
                              fontSize={"0.875rem"}
                              fontWeight={400}
                              color={
                                row.isDone
                                  ? appcolors.black
                                  : appcolors.slateGrey
                              }
                            >
                              {row.service}
                            </Typography>
                            <Typography
                              variant="h1"
                              fontSize={"0.875rem"}
                              fontWeight={400}
                              color={
                                row.isDone
                                  ? appcolors.black
                                  : appcolors.slateGrey
                              }
                            >
                              {formattedDate(row.bookingDate, false)}
                            </Typography>
                          </TableCell>
                        ) : val == "booking_time" ? (
                          <TableCell padding="normal">
                            <Stack
                              gap={1}
                              direction={"row"}
                              alignItems={"center"}
                            >
                              <Stack>
                                <Typography
                                  variant="h1"
                                  fontSize={"0.875rem"}
                                  fontWeight={400}
                                  color={
                                    row.isDone
                                      ? appcolors.emeraldGreen
                                      : appcolors.indianRed
                                  }
                                >
                                  {formattedDate(row.createdAt, false)}
                                </Typography>
                                <Typography
                                  variant="h1"
                                  fontSize={"0.875rem"}
                                  fontWeight={400}
                                  color={
                                    row.isDone
                                      ? appcolors.emeraldGreen
                                      : appcolors.indianRed
                                  }
                                >
                                  {formattedTime(row.bookingDate, true)}
                                </Typography>
                              </Stack>
                              <ArrowRightAltIcon />
                            </Stack>
                          </TableCell>
                        ) : val == "activity_detail" ? (
                          <TableCell padding="normal">
                            <Stack
                              gap={1.5}
                              direction={"row"}
                              alignItems={"center"}
                            >
                              <Typography
                                variant="body1"
                                fontSize={"0.75rem"}
                                color={appcolors.gunmetal}
                                textTransform={"capitalize"}
                              >
                                {moment(row.createdAt).format(
                                  "DDD, DD/MM/YYYY h:mm a",
                                )}
                              </Typography>
                              <Typography
                                variant="body1"
                                fontSize={"0.75rem"}
                                color={appcolors.emeraldGreen}
                                textTransform={"uppercase"}
                              >
                                {row.status}
                              </Typography>
                            </Stack>
                            <Typography
                              variant="h1"
                              fontSize={"0.875rem"}
                              fontWeight={500}
                            >
                              {row.service}
                            </Typography>
                            <Typography
                              variant="body1"
                              fontSize={"0.75rem"}
                              color={appcolors.gunmetal}
                              textTransform={"capitalize"}
                            >
                              {row.location}
                            </Typography>
                          </TableCell>
                        ) : val == "activity_price" ? (
                          <TableCell padding="normal">
                            <Stack
                              gap={1.5}
                              direction={"row"}
                              alignItems={"center"}
                            >
                              <Typography
                                variant="h1"
                                fontSize={"0.875rem"}
                                fontWeight={500}
                              >
                                {`${row.price} USD`}
                              </Typography>
                              <ArrowRightAltIcon />
                            </Stack>
                          </TableCell>
                        ) : val == "ed_new_st_req_details" ? (
                          <TableCell padding="normal">
                            <Typography
                              variant="body1"
                              fontWeight={500}
                              lineHeight={"normal"}
                            >
                              {row.username}
                            </Typography>
                            <Typography
                              fontSize={"0.8rem"}
                              lineHeight={"normal"}
                            >
                              {t("class")} : {`${row.class} ${row.section} `}
                            </Typography>

                            <Typography
                              fontSize={"0.8rem"}
                              color={appcolors.gunmetal}
                            >
                              {t("location")}: {row.location}
                            </Typography>
                          </TableCell>
                        ) : val == "worker_upcomming_job_detail" ? (
                          <TableCell padding="normal">
                            <Stack>
                              <Typography variant="body2">
                                {moment(row.start).format(
                                  "ddd,DD MMM YYYY hh:mm a",
                                )}
                                <span
                                  style={{
                                    color: "lightgreen",
                                    marginLeft: 10,
                                  }}
                                >
                                  {moment(row.start).startOf("hour").fromNow()}
                                </span>
                              </Typography>

                              <Typography
                                variant="body1"
                                fontWeight={500}
                                textTransform={"capitalize"}
                              >
                                {
                                  row.serviceSubCategoryDetails?.name[
                                    currentLanguage
                                  ]
                                }{" "}
                                {row.workerStatus === "rejected" && (
                                  <Typography
                                    variant="body2"
                                    color={"custom.venetianRed"}
                                    component={"span"}
                                  >
                                    {t("rejected")}
                                  </Typography>
                                )}
                              </Typography>
                              <Typography variant="body2">
                                {t("address")} : {row.location.address}
                              </Typography>
                            </Stack>
                          </TableCell>
                        ) : val == "worker_upcomming_job_price" ? (
                          <TableCell padding="normal">
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              gap={0.5}
                            >
                              <Typography variant="body2">
                                <span style={{ fontWeight: 500 }}>
                                  {CURRENCY}
                                </span>
                                <br />
                                {row.totalCost}
                              </Typography>
                              <ArrowRightAltIcon />
                            </Stack>
                          </TableCell>
                        ) : val == "company_sub_services" ? (
                          <TableCell padding="normal">
                            {row?.subService[currentLanguage]}
                          </TableCell>
                        ) : (
                          <TableCell padding="normal">{row[val]}</TableCell>
                        )}
                      </React.Fragment>
                    );
                  })}
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
